export default {
	featureModeControls: {
		selectFeatureHint:
			"Please select a hole / cutout in the model to assign a machining operation (thread, countersink, engraving, etc.).",
		differentTypesHint:
			"Multiple features can only be edited together if they are of the same type (e.g. adding a thread to several round holes).",
		andCutting: " and cutting",
		settingsLabel: "Settings:",
		pleaseSelectTool: "Please select...",
		pressJoinCategories: {
			all: "All press joints",
			nut: "Press nut",
			threadedStud: "Press threaded stud",
			threadedBushing: "Press threaded bushing",
		},
		noToolsForSide: "Unfortunately, no tools are available for the selected side.",
		noToolsForMaterial: "Unfortunately, this operation is not available for this material.",
		apply: "Apply",
	},
	featurePanel: {
		minimize: "minimize",
		groups: {
			screwThread: "Threads",
			countersink: "Countersinks",
			extrudedThread: "Extruded collars",
			cylinderHeadBoltHole: "Cylinder head counterbores",
			pressJoin: "Press joints",
			engraving: "Engravings",
			hole: "Round holes",
			cutout: "Cutouts",
			weldline: "Weld seams",
			anchorFace: "Top sides",
			bottomFace: "Bottom sides",
			sideFace: "Outer sides",
		},
		weldlineStatus: {
			cleaned: "ground",
			uncleaned: "unground",
		},
		labels: {
			engraving: "Engraving {id}",
			diameter: "Diameter: {value}mm",
			cutout: "Cutout {id}",
			weldline: "Weld seam {id}",
			anchorFace: "Top side {id}",
			bottomFace: "Bottom side {id}",
			sideFace: "Outer side {id}",
			weldlineTitle: "ID {id} - {length} mm",
			weldlineCornerSingular: " + corner",
			weldlineCornerPlural: " + corners",
		},
		undetermined: "Undetermined",
	},
	structurePanel: {
		minimize: "minimize",
	},
	articlePanel: {
		minimize: "minimize",
		blexonNumber: "Blexon no.:",
		material: "Material:",
		dimensions: "LxWxH:",
		saveAndClose: "Save and close",
		underReview: "Under review",
		sendToHelpdesk: "Send to helpdesk",
		additionalDesignation: {
			groundFoil: " / brushed / foil",
			foil: " / foil",
			ribbed: " / ribbed",
		},
	},
};
